import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PermisosAutomatizadosService {

  API_URL: any = environment.ENDPOINTS;

  constructor(private http: HttpClient) { }

  addProfile(data: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders();  
      headers.set('Content-Type', 'application/json; charset=utf-8');
      this.http.post(`${this.API_URL.GET_PROFILES}/profile`, data, { headers: headers })
        .subscribe( res => {
          resolve(res);
        },
      (err) => {
        reject(err);
      });
    });
  } 

  updateProfile(data: any, idPerfil: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders();  
      headers.set('Content-Type', 'application/json; charset=utf-8');
      this.http.put(`${this.API_URL.GET_PROFILES}/profile/${idPerfil}`, data, { headers: headers })
        .subscribe( res => {
          resolve(res);
        },
      (err) => {
        reject(err);
      });
    });
  } 

  getProfiles(idUsuario: number){
    return new Promise((resolve,reject) => {
      this.http.get(`${this.API_URL.GET_PROFILES}/profile/${idUsuario}`).subscribe(
        res => {
          resolve(res);
        },
        err => {
          console.log('error')
          reject(err);
        }
      )
    })
  }

  getProfilePermission(idPerfil: number){
    return new Promise((resolve,reject) => {
      this.http.get(`${this.API_URL.GET_PROFILES}/profile/${idPerfil}/modules`).subscribe(
        res => {
          resolve(res);
        },
        err => {
          console.log('error')
          reject(err);
        }
      )
    })
  }

  getFunctions(idUdn: number){
    return new Promise((resolve,reject) => {
      this.http.get(`${this.API_URL.GET_PROFILES}/functions/${idUdn}`).subscribe(
        res => {
          resolve(res);
        },
        err => {
          console.log('error')
          reject(err);
        }
      )
    })
  }

  getModules(idUdn: number){
    return new Promise((resolve,reject) => {
      this.http.get(`${this.API_URL.GET_PROFILES}/module/${idUdn}`).subscribe(
        res => {
          resolve(res);
        },
        err => {
          console.log('error')
          reject(err);
        }
      )
    })
  }

  deleteProfile(idProfile: number, idUser: number){
    return new Promise((resolve, reject) => {
      this.http.delete(`${this.API_URL.GET_PROFILES}/module/${idProfile}/user/${idUser}`)
        .subscribe( res => {
          resolve(res);
        },
      (err) => {
        reject(err);
      });
    });
  }

  validateEmpleados(data: any){
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = { headers: headers };
    return new Promise((resolve,reject)=> {
      this.http.post(`${this.API_URL.VALIDATE_EMPLOYEES}/employee-validation-name`, data, params).subscribe(
        res => resolve(res),
        error => {
          console.log(error)
          reject(error)
        }
      );
    });
  }

  validateEmpleadosOld(data: any){
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = { headers: headers };
    return new Promise((resolve,reject)=>{
      this.http.post(`${this.API_URL.VALIDATION_OLD}/getValidation`,data,params).subscribe(
        res => resolve(res),
        error => {
          console.log(error)
          reject(error)
        }
      );
    });
  }

  getEmployeesValidX3(data){
    return new Promise((resolve, reject) => {
      this.http.post(this.API_URL.BASE_RU + '/validacion-comunicados/tareas', data).subscribe((response) => {
        resolve(response);
      }, (err) => {
        reject(err)
      })
    });
  }


}
